import { Callout } from '@ekhodealer/ekho-common/rev';

import { PageLayout } from '@common/components/PageLayout';
import { useCurrentServicesProvider } from '@common/hooks/useCurrentServicesProvider';

export default function AnalyticsPage() {
	const { data: servicesProvider } = useCurrentServicesProvider();
	const analyticsUrl = (servicesProvider as unknown as { analyticsBoardUrl?: string })?.analyticsBoardUrl;

	return (
		<PageLayout title='Analytics'>
			{!analyticsUrl ? (
				<Callout title='No analytics dashboard configured' variant='error'>
					There is no analytics dashboard configured for this services provider.
				</Callout>
			) : (
				<iframe
					src={analyticsUrl}
					style={{
						width: '100%',
						height: '100%',
						border: 'none',
						borderRadius: '8px',
						boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
					}}
					title='Analytics Dashboard'
				/>
			)}
		</PageLayout>
	);
}
